import styleUtils from 'shared-components/styles/util.module.css'
import PostRow from 'shared-components/posts/PostRow'
import AuthorBig from 'shared-components/ui/AuthorBig'
import SidebarLayout from 'shared-components/ui/SidebarLayout'
import LoadMoreList from 'shared-components/ui/LoadMoreList'
import styles from './AuthorTemplate.module.css'
import { useCallback } from 'react'
import { DSAuthorPage, DSPostShort, DSPostShortWithAuthor } from 'shared-definitions/types'

interface AuthorTemplateProps {
  page: DSAuthorPage
  pageLoader: (page: number, perPage: number) => Promise<DSPostShortWithAuthor[]>
  augmenter: (input: DSPostShort) => DSPostShortWithAuthor
  sideBar: React.ReactElement
}

const AuthorTemplate: React.VFC<AuthorTemplateProps> = ({
  page,
  augmenter,
  pageLoader,
  sideBar,
}) => (
  <div className={styleUtils.wrapper}>
    <AuthorBig className={styles.preview} item={page.author} />
    <SidebarLayout
      content={
        <LoadMoreList
          autoload
          render={useCallback(
            (item: DSPostShortWithAuthor, index) => (
              <PostRow key={index} post={item} large />
            ),
            []
          )}
          className={styles.list}
          initial={{ ...page.posts, items: page.posts.items.map(augmenter) }}
          loader={pageLoader}
        />
      }
      sidebar={sideBar}
    />
  </div>
)

export default AuthorTemplate
